export const transformTopicsResult = (data) => {
  return data?.map((item) => ({ ...item, theme_name: item?.name }));
};
